import { NgModule } from "@angular/core";
import { MaterialAppModule } from "../ngmaterial.module";

import { ClientAccessComponent } from "./client-access.component";
import { CommonModule } from "../common/common.module";

@NgModule({
	imports: [
		CommonModule,
		MaterialAppModule
	],
	declarations: [
		ClientAccessComponent
	],
})
export class ClientAccessModule { }
